import { render, staticRenderFns } from "./PageAppointmentsSettings.vue?vue&type=template&id=88261360&"
import script from "./PageAppointmentsSettings.vue?vue&type=script&lang=ts&"
export * from "./PageAppointmentsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports